import $ from 'jquery';
import _ from 'underscore';
import Backbone from 'backbone';
import defaultTemplate from 'hbars!templates/defaultTemplate';

var RenderedView = Backbone.View.extend({

    preRender: function(){},
    postRender: function(){},

    _preRender: function() {
        this.preRender();
    },

    _postRender: function() {
        this.postRender();
    },

    remove: function() {
        return Backbone.View.prototype.remove.call(this);
    },

    render: function(template, templateData) {
        var chosenTemplate = template || defaultTemplate;
        this._preRender();
        if (!this.$el.data('server-rendered')) {
            var data =(this.model && this.model.toJSON()) || {};
            var html = '';

            if (data.renderedHtml){
                html = data.renderedHtml;
            } else {
                html = chosenTemplate(templateData || data);
            }

            this.$el.html(html);
        } else {
            this.$el.data('server-rendered', false);
        }

        this._postRender();
        return this;
    }
});

export default RenderedView;


